import React from 'react'

const Help = () => {
  return (
    <div>index</div>
  )
}

export default Help